import { cn } from './chunk-FFX3LZW7.js';
import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { jsx } from 'react/jsx-runtime';

var buttonVariants = cva(
  "inline-flex min-w-0 max-w-full items-center justify-center whitespace-normal [overflow-wrap:anywhere] rounded-md text-center text-sm font-medium transition-colors disabled:pointer-events-none disabled:opacity-50 focus-ring",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        brand: "bg-brand text-brand-foreground hover:bg-brand/90",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "min-h-9 px-4 py-2",
        sm: "min-h-8 rounded-md px-3 py-1 text-xs",
        lg: "min-h-10 rounded-md px-8 py-2",
        icon: "size-9"
      }
    },
    defaultVariants: { variant: "default", size: "default" }
  }
);
var Button = React.forwardRef(function Button2({ className, variant, size, asChild = false, ...props }, ref) {
  const Comp = asChild ? Slot : "button";
  return /* @__PURE__ */ jsx(Comp, { className: cn(buttonVariants({ variant, size, className })), ref, ...props });
});

export { Button, buttonVariants };
//# sourceMappingURL=chunk-QJZK7P2F.js.map
//# sourceMappingURL=chunk-QJZK7P2F.js.map